import { combineReducers } from 'redux'
import { messageReducer } from './message/reducer'
import { userReducer } from './user/reducer'
import { chatReducer } from '@/redux/chat/reducer'
import { contactReducer } from '@/redux/contact/reducer'
import { companyReducer } from '@/redux/company/reducer'
import { departmentReducer } from './department/reducer'
import { stickerReducer } from './sticker/reducer'
import { themeReducer } from './theme/reducer'
import { quickReplyReducer } from './quickReply/reducer'
import { campaignReducer } from './campaign/reducer'
import { customButtonReducer } from './custom-button/reducer'
import { labelReducer } from './label/reducer'
import { followupReducer } from './followup/reducer'

export default combineReducers({
  messageReducer,
  chatReducer,
  userReducer,
  contactReducer,
  companyReducer,
  departmentReducer,
  stickerReducer,
  themeReducer,
  quickReplyReducer,
  campaignReducer,
  customButtonReducer,
  labelReducer,
  followupReducer
})
